import { render, staticRenderFns } from "./V2Welcome.vue?vue&type=template&id=5c30e020&scoped=true&"
import script from "./V2Welcome.vue?vue&type=script&lang=js&"
export * from "./V2Welcome.vue?vue&type=script&lang=js&"
import style0 from "./V2Welcome.vue?vue&type=style&index=0&id=5c30e020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c30e020",
  null
  
)

export default component.exports